/**
 * AIストラテジー - Easy（かんたん）
 *
 * - ランダムに1枚だけ召喚
 * - 攻撃は直接攻撃優先
 * - スキル・トリガーは使用しない
 */

import type { CardWithId, MonsterInstance } from '../../../types/card';
import { baseStrategy, randomPick, type AIGameState, type AIStrategy, type UsableSkill } from './base';

export const easyStrategy: AIStrategy = {
  ...baseStrategy,

  // 1枚だけランダム召喚（30%の確率で召喚しない）
  chooseSummon(summonableCards: CardWithId[], gameState: AIGameState): CardWithId | null {
    if (summonableCards.length === 0) return null;
    if (Math.random() < 0.3) return null;
    return randomPick(summonableCards);
  },

  // 直接攻撃を優先（70%）
  chooseAttackTarget(validTargets: (number | 'direct')[], attacker: MonsterInstance, gameState: AIGameState): number | 'direct' {
    if (validTargets.length === 0) return 'direct';
    if (validTargets.includes('direct')) {
      return Math.random() < 0.7 ? 'direct' : (randomPick(validTargets) ?? 'direct');
    }
    return randomPick(validTargets) ?? 'direct';
  },

  // スキルは使用しない
  chooseSkill(usableSkills: UsableSkill[], gameState: AIGameState): UsableSkill | null {
    return null;
  },

  // トリガーは発動しない
  chooseTrigger(activatableTriggers: unknown[], gameState: AIGameState): unknown | null {
    return null;
  },

  // 刹那詠唱は発動しない
  chooseSetsuna(availableSetsunaCards: CardWithId[], chainContext: unknown, gameState: AIGameState): CardWithId | null {
    return null;
  },

  // 魔法カードは使用しない
  chooseMagicCard(usableMagicCards: CardWithId[], gameState: AIGameState): CardWithId | null {
    return null;
  },

  // フィールドカードは配置しない（戦略的価値を理解していない）
  chooseFieldCard(placeableFieldCards: CardWithId[], gameState: AIGameState): CardWithId | null {
    return null;
  },

  // フェイズカードは配置しない
  choosePhaseCard(placeablePhaseCards: CardWithId[], gameState: AIGameState): CardWithId | null {
    return null;
  },
};
